import { transport } from 'config/transport';

export function callApiExportCongDoanReportForAllCongDoanMonthly(yearMonth, pdf = false, abroadOnly = false) {
    return transport.get(`/trunguong/report/congdoan`, { params: { yearMonth, pdf, abroadOnly }, responseType: 'blob' });
}
